import { AiFillCheckCircle } from 'react-icons/ai'
import {
  BsBag,
  BsCashCoin,
  BsGraphUp,
  BsHandbagFill,
  BsPersonFill,
  BsThreeDots,
} from 'react-icons/bs'
import { CgFileDocument } from 'react-icons/cg'
import { FaCashRegister, FaShoppingBag } from 'react-icons/fa'
import { FiMinus } from 'react-icons/fi'
import { HiAdjustments, HiDocumentText, HiShoppingBag } from 'react-icons/hi'
import { IoMdAdd } from 'react-icons/io'
import {
  IoBarChartSharp,
  IoCalendar,
  IoCashSharp,
  IoDocuments,
  IoPersonAddSharp,
  IoWallet,
} from 'react-icons/io5'
import { SiGraphql } from 'react-icons/si'
import {
  Area,
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ComposedChart,
  LabelList,
  Legend,
  Line,
  LineChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import FloatingMenu from '../../components/Display/FloatingMenu'
import { formatPipe, getDenomination } from '../../utils/utils'
import '../../layout/DashboardStats.css'
import { toFixed } from 'accounting'
import { FloatingMenuContext } from '../../context/FloatingMenuContext'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import Modal from '../../components/Display/Modal'
import { DashboardStatsClass } from '../../layout/DashboardClass'
import { ThemeContext } from '../../context/ThemeContext'
import { getJsonFromS3 } from '../../utils/UploadFile'
import { useHistory } from 'react-router'
import { BiMoney } from 'react-icons/bi'
import { useContext, useEffect, useState } from 'react'
import { IStats } from '../../layout/DashboardStats'
import Switch from '@mui/material/Switch'
import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material'
export const StatsView = () => {
  const [stats, setStats] = useState<IStats | null>(null)

  const user = useSelector((state: RootState) => state?.auth?.user)

  const [salesInformation, setSalesInformation] = useState<any[]>([])

  const [isUsd, setIsUsd] = useState<boolean>(false)

  const [category, setCategory] = useState<any[]>([])

  const { theme } = useContext(ThemeContext)

  const [selectedType, setselectedType] = useState('annual')

  const [isProducts, setIsProducts] = useState<boolean>(false)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsUsd(event.target.checked)
  }

  const handleChangeProducts = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsProducts(event.target.checked)
  }

  const handleChangeDropdown = (event: SelectChangeEvent) => {
    setselectedType(event.target.value as string)
  }

  let objTransform = {
    1: 'Enero',
    2: 'Febrero',
    3: 'Marzo',
    4: 'Abril',
    5: 'Mayo',
    6: 'Junio',
    7: 'Julio',
    8: 'Agosto',
    9: 'Septiembre',
    10: 'Octubre',
    11: 'Noviembre',
    12: 'Diciembre',
  }

  const getStats = async () => {
    // try {
    //   let re = await getJsonFromS3(user['custom:tenant_id'])
    //   console.log("RESPONSE", re)
    // } catch (err) {
    //   console.log("RESPONSE 2", err)
    // }

    // let res = await fetch(
    //   'https://nevula-docs-bucket-test-12db7f23c30b.s3.amazonaws.com/123bdsahv/DashboardStats.json'
    // )
    let response: IStats | null = null
    try {
      response = await getJsonFromS3(user['custom:tenant_id'])
      console.log('DASHBOARD STATS', response)
    } catch (err) {
      let dashboardStats = new DashboardStatsClass()
      setStats(dashboardStats)
    }
    if (response) {
      console.log('LLEGA...')
      // setStats({...response, monthIncome: {
      //   usdAmount: "20",
      //   bsAmount: "50"
      // }} )

      onSetSalesByMonth(response)

      // response.inventory.categories = [
      //   { name: 'Salsa', percentage: 10, totalQty: '2' },
      //   { name: 'Carne', percentage: 5, totalQty: '2' },
      //   { name: 'Atun', percentage: 10, totalQty: '2' },
      //   { name: 'Pollo', percentage: 10, totalQty: '2' },
      //   { name: 'Arroz', percentage: 65, totalQty: '2' },
      // ]

      onSetCategory(response)

      // response.sales.currentMonthSales = [
      //   {
      //     //@ts-ignore
      //     bsTotal: '1200.8',
      //     usdTotal: '296.80',
      //     date: '2022-10-15',
      //   },
      //   {
      //     //@ts-ignore
      //     bsTotal: '872.4',
      //     usdTotal: '145.40',
      //     date: '2022-10-25',
      //   },
      // ]

      setStats({
        ...response,
        //     netCashFlow: { bs: 20, cop: 30, eur: 10, usd: 15 },
        //     // netCashFlow: { usdAmount: 10, bsAmount: 50 },
        //     // monthIncome: { bsAmount: '50', usdAmount: '10' },
        //     // monthOutflow: { bsAmount: '50', usdAmount: '10' },
        //     accountReceivables: { bsAmount: '90', usdAmount: '20000' },
        //     accountPayables: { bsAmount: '40', usdAmount: '30' },
        //     inventory: {
        //       categories: [
        //         { name: 'Carnes', percentage: 20, totalQty: '10' },
        //         { name: 'Viveres', percentage: 40, totalQty: '20' },
        //         { name: 'Pollos', percentage: 30, totalQty: '5' },
        //       ],
        //       totalInv: '1000',
        //     },
        //     topSoldProducts: {
        //       products: {
        //         allYear: [
        //           { id_item: '10', name: 'fijewoife', totalQuantity: '150' },
        //           { id_item: '9', name: 'fijewoife', totalQuantity: '140' },
        //           { id_item: '8', name: 'fijewoife', totalQuantity: '130' },
        //           { id_item: '7', name: 'fijewoife', totalQuantity: '120' },
        //           { id_item: '6', name: 'fijewoife', totalQuantity: '110' },
        //           { id_item: '5', name: 'efiefioewf', totalQuantity: '100' },
        //           { id_item: '4', name: 'fijewoife', totalQuantity: '90' },
        //           { id_item: '3', name: 'Pan', totalQuantity: '80' },
        //           { id_item: '2', name: 'Trigo', totalQuantity: '70' },
        //           { id_item: '1', name: 'Harina', totalQuantity: '60' },
        //         ],
        //         currentMonth: [
        //           { id_item: '10', name: 'mes 01 producto', totalQuantity: '150' },
        //         ],
        //       },
        //       services: {
        //         allYear: [
        //           { id_service: '1', name: 'Harina', totalQuantity: '60' },
        //           { id_service: '2', name: 'Harina', totalQuantity: '30' },
        //           { id_service: '2', name: 'Harina', totalQuantity: '30' },
        //           { id_service: '2', name: 'Harina', totalQuantity: '30' },
        //           // { id_service: '2', name: 'Harina', totalQuantity: '90' },
        //         ],
        //         currentMonth: [],
        //       },
        //     },
        //     clients: {
        //       totalQty: '50',
        //       newInMonth: '5',
        //     },
        // bankBalance: {
        //   accounts: [
        //     { balance: '1162.40', description: 'Cuenta Egresos' },
        //     { balance: '590.00', description: 'EFECTIVO DOLARES' },
        //     { balance: '900.00', description: 'EFECTIVO Electronico' },
        //   ],
        //   totalBalance: '900.00'
        // },
        //     sales: {
        //       salesByMonth: response.sales.salesByMonth,
        //       currentMonthSales: response.sales.currentMonthSales.map((v) => ({
        //         ...v,
        //         bsTotal: +v.bsTotal,
        //       })),
        //     },
      })
    }
  }

  useEffect(() => {
    console.log('USER', user)
    if (user) {
      getStats()
    }
  }, [user])

  const onSetSalesByMonth = (response) => {
    // response.sales.salesByMonth = [
    //   { bsTotal: '1500.00', month: 1, usdTotal: '900.20' },
    //   ...response.sales.salesByMonth,
    // ]

    let sales = response.sales.salesByMonth.map((v) => ({
      ...v,
      [objTransform[v.month]]: +v.bsTotal,
      month: objTransform[v.month],
    }))

    setSalesInformation(sales)
  }

  const onSetCategory = (response) => {
    let categoryLocal = response.inventory.categories.slice(0, 3)

    let otherCategories = response.inventory.categories.slice(3)

    let otherCategoriesSum = +toFixed(
      otherCategories.reduce(
        (a, b) => +toFixed(a, 2) + +toFixed(b.percentage, 2),
        0
      ),
      2
    )

    if (otherCategories.length === 0) {
      setCategory(categoryLocal)
    } else {
      setCategory([
        ...categoryLocal,
        { name: 'Otros', percentage: otherCategoriesSum },
      ])
    }
  }

  const colors = ["#1400FF", "#0033A0", "#1245B1", "#00C2FF"]

  const RenderTooltip = (prop) => {
    // const { x, y, stroke, payload, name, height, index } = prop;
    // const fireOffset = value.toString().length < 5;
    // const offset = fireOffset ? -40 : 5;
    //   return (
    //     <g transform={`translate(${x},${y})`}>
    //     <text x={0} y={0} dy={16} fill="#666">
    //       <tspan textAnchor="middle" x="0">
    //         {name}
    //       </tspan>
    //     </text>
    //   </g>
    // );
    // return (
    //   <g transform={`translate(${x},${y})`}>
    //      <text x={0} y={0} dy={16} fill="#666" transform='rotate(-90)'>
    //        <tspan textAnchor="middle" x="0">
    //          {name}
    //        </tspan>
    //      </text>
    // </g>
    // )
    return (
      <div className="custom-tooltip">
        <p
          className="label"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 120,
            color: 'black',
          }}
        >{`${
          !isProducts
            ? stats?.topSold?.services?.allYear[prop?.label]?.name
            : stats?.topSold?.products?.allYear[prop?.label]?.name
        }`}</p>
        <p className="label" style={{ color: 'black' }}>{`${
          !isProducts
            ? stats?.topSold?.services?.allYear[prop?.label]?.totalQuantity
            : stats?.topSold?.products?.allYear[prop?.label]?.totalQuantity
        }`}</p>
      </div>
    )
  }

  return (
    <div className="h-full">

<div className="flex flex-row items-center">
          <Switch checked={isUsd} onChange={handleChange} />
          <label className="font-semibold text-black text-center">
            Mostrar en USD (Ref.)
          </label>
        </div>

      <div
        className="div1 relative shadow-lg overflow-x-auto overflow-y-hidden"
        style={{
          backgroundColor: '#F6F7FC',
          borderColor: '',
          borderWidth: 0,
        }}
      >
        <div className="flex justify-between w-full">
          <div className="flex">
            <div
              style={{
                height: 28,
                width: 28,
                borderRadius: 20,
                backgroundColor: '#507CDC',
              }}
              className="mr-3 flex justify-center items-center"
            >
              <div
                style={{
                  backgroundColor: '#FDFDFD',
                  borderRadius: 20,
                  height: 15,
                  width: 15,
                }}
                className="flex justify-center items-center"
              >
                <IoMdAdd size={20} color={'#507CDC'} />
              </div>
            </div>

            <label className="font-semibold">Ingresos del Mes</label>
          </div>

          {/* <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={selectedCard === 0}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots className="cursor-pointer" onClick={() => setSelectedCard(0)} />
            </FloatingMenu> */}
        </div>

        <div className="mt-14">
          <BarChart
            width={320}
            height={250}
            // barCategoryGap="20%" 
            barSize={30}
            data={[
              {
                value: stats?.monthIncome.usd ? +stats?.monthIncome.usd : 0,
                name: "$USD"
              },
              {
                value: stats?.monthIncome.bs ? +stats?.monthIncome.bs : 0,
                name: "Bs."
              },
              {
                value: stats?.monthIncome?.eur
                  ? +stats?.monthIncome?.eur
                  : 0,
                name: "EUR"
              },
              {
                value: stats?.monthIncome?.cop
                  ? +stats?.monthIncome?.cop
                  : 0,
                name: "COP"
              },
            ]}
           
            // style={{ marginLeft: '-80px' }}
          >
            {/* <CartesianGrid strokeDasharray="3 3" /> */}
            {/* <XAxis dataKey="name" /> */}
            {/* <Tooltip /> */}

            {/* <Legend
              wrapperStyle={{ left: "25%", bottom: 0, width: 150, marginTop: 10 }}
              layout="vertical"
              iconSize={10}
              // payload={data.map((item, idx) => ({
              //   id: d,
              //   value: `${item.$USD ? '$USD' : 'VEN'} ${
              //     item?.$USD || item?.VEN
              //   }`,
              // }))}
              payload={[
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        $USD
                      </strong>
                      {stats?.monthIncome.usd
                        ? formatPipe(stats?.monthIncome.usd + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#1400FF',
                },
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        Bs
                      </strong>
                      {stats?.monthIncome.bs
                        ? formatPipe(stats?.monthIncome.bs + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#0033A0',
                },
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        EUR
                      </strong>
                      {stats?.monthIncome.bs
                        ? formatPipe(stats?.monthIncome.eur + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#1245B1',
                },
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        COP
                      </strong>
                      {stats?.monthIncome.cop
                        ? formatPipe(stats?.monthIncome.cop + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#00C2FF',
                },
              ]}
            /> */}

            <XAxis dataKey="name" />
            <YAxis dataKey="value" />


            <Bar dataKey="value"   fill="#1400FF" fontWeight="bold">
              { [
              {
                value: stats?.monthIncome.usd ? +stats?.monthIncome.usd : 0,
                name: "$USD"
              },
              {
                value: stats?.monthIncome.bs ? +stats?.monthIncome.bs : 0,
                name: "Bs."
              },
              {
                value: stats?.monthIncome?.eur
                  ? +stats?.monthIncome?.eur
                  : 0,
                name: "EUR"
              },
              {
                value: stats?.monthIncome?.cop
                  ? +stats?.monthIncome?.cop
                  : 0,
                name: "COP"
              },
            ].map((value, idx) => {
              return <Cell key={`cell-${idx}`} fill={colors[idx]} />
            }) }
            </Bar>
            {/* <Bar dataKey="value" fill="#0033A0" fontWeight="bold" />
            <Bar dataKey="value" fill="#1245B1" fontWeight="bold" />
            <Bar dataKey="value" fill="#00C2FF" fontWeight="bold" /> */}
          </BarChart>
        </div>

        {/* <div
            className="flex justify-end absolute items-center"
            style={{ bottom: 0, padding: 'inherit', right: 0 }}
          >
            <IoCalendar className="text-primary mr-3" />
            <label className="text-xs">Filtrado Mes: Julio 2022</label>
          </div> */}
      </div>

      <div
        className="div2 relative shadow-lg overflow-x-auto overflow-y-hidden mt-5"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <div className="flex justify-between w-full">
          <div className="flex">
            <div
              style={{
                height: 28,
                width: 28,
                borderRadius: 20,
                backgroundColor: '#507CDC',
              }}
              className="mr-3 flex justify-center items-center"
            >
              <div
                style={{
                  backgroundColor: '#FDFDFD',
                  borderRadius: 20,
                  height: 15,
                  width: 15,
                }}
                className="flex justify-center items-center"
              >
                <FiMinus size={20} color={'#507CDC'} />
              </div>
            </div>

            <label className="font-semibold">Egresos del Mes</label>
          </div>

          {/* <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={selectedCard === 1}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots className="cursor-pointer" onClick={() => setSelectedCard(1)} />
            </FloatingMenu> */}
        </div>

        <div className="mt-14">
          <BarChart
            width={320}
            height={250}
            barSize={30}

            data={[
              {
                value: stats?.monthOutflow.usd
                  ? +stats?.monthOutflow.usd
                  : 0,
                  name: "$USD"
              },
              {
                value: stats?.monthOutflow.bs ? +stats?.monthOutflow.bs : 0,
                name: "Bs."
              },
              {
                value: stats?.monthOutflow?.eur
                  ? +stats?.monthOutflow?.eur
                  : 0,
                  name: "EUR"

              },
              {
                value: stats?.monthOutflow?.cop
                  ? +stats?.monthOutflow?.cop
                  : 0,
                  name: "COP"
              },
            ]}
          
          >
            {/* <CartesianGrid strokeDasharray="3 3" /> */}
            {/* <XAxis dataKey="name" /> */}
            {/* <Tooltip /> */}
            {/* <Legend
              wrapperStyle={{ left: 300, top: 20, width: 150 }}
              layout="vertical"
              iconSize={10}
              payload={[
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        $USD
                      </strong>
                      {stats?.monthOutflow.usd
                        ? formatPipe(stats?.monthOutflow.usd + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#1400FF',
                },
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        Bs
                      </strong>
                      {stats?.monthOutflow.bs
                        ? formatPipe(stats?.monthOutflow.bs + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#0033A0',
                },
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        EUR
                      </strong>
                      {stats?.monthOutflow.bs
                        ? formatPipe(stats?.monthIncome.eur + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#1245B1',
                },
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        COP
                      </strong>
                      {stats?.monthOutflow.cop
                        ? formatPipe(stats?.monthIncome.cop + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#00C2FF',
                },
              ]}
            /> */}

            
            <XAxis dataKey="name" />
            <YAxis dataKey="value" />

            <Bar dataKey="value"   fill="#1400FF" fontWeight="bold">
              { [
              {
                value: stats?.monthOutflow.usd
                  ? +stats?.monthOutflow.usd
                  : 0,
                  name: "$USD"
              },
              {
                value: stats?.monthOutflow.bs ? +stats?.monthOutflow.bs : 0,
                name: "Bs."
              },
              {
                value: stats?.monthOutflow?.eur
                  ? +stats?.monthOutflow?.eur
                  : 0,
                  name: "EUR"

              },
              {
                value: stats?.monthOutflow?.cop
                  ? +stats?.monthOutflow?.cop
                  : 0,
                  name: "COP"
              },
            ].map((value, idx) => {
              return <Cell key={`cell-${idx}`} fill={colors[idx]} />
            }) }
            </Bar>

            {/* <Bar dataKey="usdAmount" fill="#1400FF" fontWeight="bold" />
            <Bar dataKey="bsAmount" fill="#0033A0" fontWeight="bold" />
            <Bar dataKey="eurAmount" fill="#1245B1" fontWeight="bold" />
            <Bar dataKey="copAmount" fill="#00C2FF" fontWeight="bold" /> */}
          </BarChart>
        </div>

        {/* <div
            className="flex justify-end absolute items-center"
            style={{ bottom: 0, padding: 'inherit', right: 0 }}
          >
            <IoCalendar className="text-primary mr-3" />
            <label className="text-xs">Filtrado Mes: Julio 2022</label>
          </div> */}
      </div>

      <div className="flex mt-5">
        <div
          style={{
            height: 28,
            width: 28,
            borderRadius: 20,
            backgroundColor: '#FFFFFF',
          }}
          className="mr-3 flex justify-center items-center"
        >
          <div
            style={{
              backgroundColor: '#FDFDFD',
              borderRadius: 20,
              height: 15,
              width: 15,
            }}
            className="flex justify-center items-center"
          >
            <IoWallet size={20} color={'#507CDC'} />
          </div>
        </div>

        <label className="font-semibold">Saldos en banco</label>
      </div>

      <div
        className="div2 relative shadow-lg overflow-x-auto overflow-y-hidden mt-2"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <div className="text-center">
          <label className="font-semibold text-primary text-center">
            Saldo total de las cuentas:
          </label>
        </div>

        <div className="text-center">
          <label className="font-semibold text-primary ">
            {`Bs. ${formatPipe(
              stats?.bankBalance?.totalBalance + '',
              false,
              2,
              -99999999999
            )}`}
          </label>
        </div>
      </div>

      <div className="flex mt-5">
        <div
          style={{
            height: 28,
            width: 28,
            borderRadius: 20,
            backgroundColor: '#FFFFFF',
          }}
          className="mr-3 flex justify-center items-center"
        >
          <div
            style={{
              backgroundColor: '#FDFDFD',
              borderRadius: 20,
              height: 15,
              width: 15,
            }}
            className="flex justify-center items-center"
          >
            <HiDocumentText size={20} className="text-primary" />
          </div>
        </div>

        <label className="font-semibold">Facturación diaria</label>
      </div>

      <div
        className="div2 relative shadow-lg overflow-x-auto overflow-y-hidden mt-2"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        {/* <div className="flex flex-row justify-center w-full items-center">
          <Switch checked={isUsd} onChange={handleChange} />
          <label className="font-semibold text-black text-center">
            Mostrar en USD (Ref.)
          </label>
        </div> */}

        <div className="flex flex-row justify-center w-full mt-2">
          <div className="text-center">
            <label className="font-semibold text-primary text-center">
              Efectivo:
            </label>
          </div>

          <div className="text-center">
            <label className="font-semibold text-primary ml-2">
              {isUsd
                ? stats?.dayBilling?.usdCash
                  ? `$ ${formatPipe(stats?.dayBilling?.usdCash)}`
                  : formatPipe(0 + '')
                : stats?.dayBilling?.bsCash
                ? `Bs. ${formatPipe(stats?.dayBilling?.bsCash)}`
                : formatPipe(0 + '')}
            </label>
          </div>
        </div>

        <div className="flex flex-row justify-center w-full mt-2">
          <div className="text-center">
            <label className="font-semibold text-primary text-center">
              Digital:
            </label>
          </div>

          <div className="text-center ml-2">
            <label className="font-semibold text-primary ">
              {isUsd
                ? stats?.dayBilling?.usdDigital
                  ? `$ ${formatPipe(stats?.dayBilling?.usdDigital)}`
                  : formatPipe(0 + '')
                : stats?.dayBilling?.bsDigital
                ? `Bs. ${formatPipe(stats?.dayBilling?.bsDigital)}`
                : formatPipe(0 + '')}
            </label>
          </div>
        </div>
      </div>

      <div
        className="div1 relative shadow-lg overflow-x-auto overflow-y-hidden mt-2"
        style={{
          backgroundColor: '#F6F7FC',
          borderColor: '',
          borderWidth: 0,
        }}
      >
        <div className="flex justify-between w-full">
          <div className="flex">
            <div
              style={{
                height: 28,
                width: 28,
                borderRadius: 20,
                backgroundColor: '#507CDC',
              }}
              className="mr-3 flex justify-center items-center"
            >
              <div
                style={{
                  backgroundColor: '#FDFDFD',
                  borderRadius: 20,
                  height: 15,
                  width: 15,
                }}
                className="flex justify-center items-center"
              >
                <IoMdAdd size={20} color={'#507CDC'} />
              </div>
            </div>

            <label className="font-semibold">Ventas por día</label>
          </div>

          {/* <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={selectedCard === 0}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots className="cursor-pointer" onClick={() => setSelectedCard(0)} />
            </FloatingMenu> */}
        </div>

        <div className="mt-14">
          <BarChart
            width={320}
            height={250}
            data={[
              {
                value: stats?.monthIncome.usd ? +stats?.monthIncome.usd : 0,
                name: "$USD"
              },
              {
                value: stats?.monthIncome.bs ? +stats?.monthIncome.bs : 0,
                name: "Bs."

              },
              {
                value: stats?.monthIncome?.eur
                  ? +stats?.monthIncome?.eur
                  : 0,
                  name: "EUR"

              },
              {
                value: stats?.monthIncome?.cop
                  ? +stats?.monthIncome?.cop
                  : 0,
                  name: "COP"

              },
            ]}
            barSize={30}
          >
            {/* <CartesianGrid strokeDasharray="3 3" /> */}
            {/* <XAxis dataKey="name" /> */}
            {/* <Tooltip /> */}

            {/* <Legend
              wrapperStyle={{ left: 300, top: 20, width: 150 }}
              layout="vertical"
              iconSize={10}
              // payload={data.map((item, idx) => ({
              //   id: d,
              //   value: `${item.$USD ? '$USD' : 'VEN'} ${
              //     item?.$USD || item?.VEN
              //   }`,
              // }))}
              payload={[
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        $USD
                      </strong>
                      {stats?.monthIncome.usd
                        ? formatPipe(stats?.monthIncome.usd + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#1400FF',
                },
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        Bs
                      </strong>
                      {stats?.monthIncome.bs
                        ? formatPipe(stats?.monthIncome.bs + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#0033A0',
                },
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        EUR
                      </strong>
                      {stats?.monthIncome.bs
                        ? formatPipe(stats?.monthIncome.eur + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#1245B1',
                },
                {
                  value: (
                    <label style={{ fontWeight: 500, fontSize: 14 }}>
                      <strong style={{ marginRight: 3, fontWeight: 600 }}>
                        COP
                      </strong>
                      {stats?.monthIncome.cop
                        ? formatPipe(stats?.monthIncome.cop + '')
                        : formatPipe(0 + '')}
                    </label>
                  ),
                  color: '#00C2FF',
                },
              ]}
            /> */}

            <XAxis dataKey="name" />
            <YAxis dataKey="value" />

            <Bar dataKey="value"   fill="#1400FF" fontWeight="bold">
              { [
              {
                value: stats?.monthIncome.usd ? +stats?.monthIncome.usd : 0,
                name: "$USD"
              },
              {
                value: stats?.monthIncome.bs ? +stats?.monthIncome.bs : 0,
                name: "Bs."

              },
              {
                value: stats?.monthIncome?.eur
                  ? +stats?.monthIncome?.eur
                  : 0,
                  name: "EUR"

              },
              {
                value: stats?.monthIncome?.cop
                  ? +stats?.monthIncome?.cop
                  : 0,
                  name: "COP"

              },
            ].map((value, idx) => {
              return <Cell key={`cell-${idx}`} fill={colors[idx]} />
            }) }
            </Bar>

            {/* <Bar dataKey="usdAmount" fill="#1400FF" fontWeight="bold" />
            <Bar dataKey="bsAmount" fill="#0033A0" fontWeight="bold" />
            <Bar dataKey="eurAmount" fill="#1245B1" fontWeight="bold" />
            <Bar dataKey="copAmount" fill="#00C2FF" fontWeight="bold" /> */}
          </BarChart>
        </div>

        {/* <div
            className="flex justify-end absolute items-center"
            style={{ bottom: 0, padding: 'inherit', right: 0 }}
          >
            <IoCalendar className="text-primary mr-3" />
            <label className="text-xs">Filtrado Mes: Julio 2022</label>
          </div> */}
      </div>

      <div className="flex mt-5">
        <div
          style={{
            height: 28,
            width: 28,
            borderRadius: 20,
            backgroundColor: '#FFFFFF',
          }}
          className="mr-3 flex justify-center items-center"
        >
          <div
            style={{
              backgroundColor: '#FDFDFD',
              borderRadius: 20,
              height: 15,
              width: 15,
            }}
            className="flex justify-center items-center"
          >
            <FaShoppingBag size={20} color={'#507CDC'} />
          </div>
        </div>

        <label className="font-semibold">Cuentas por pagar</label>
      </div>

      <div
        className="div2 relative shadow-lg overflow-x-auto overflow-y-hidden mt-2"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        {/* <div className="flex flex-row justify-center w-full items-center">
          <Switch checked={isUsd} onChange={handleChange} />
          <label className="font-semibold text-black text-center">
            Mostrar en USD (Ref.)
          </label>
        </div> */}

        <div className="text-center">
          <label className="font-semibold text-primary ">
            {isUsd
              ? stats?.accountPayables?.usdAmount
                ? `$ ${formatPipe(stats?.accountPayables.usdAmount)}`
                : `$ ${formatPipe(0 + '')}`
              : stats?.accountPayables.usdAmount
              ? `Bs. ${formatPipe(stats?.accountPayables.bsAmount)}`
              : `Bs. ${formatPipe(0 + '')}`}
          </label>
        </div>
      </div>

      <div className="flex mt-5">
        <div
          style={{
            height: 28,
            width: 28,
            borderRadius: 20,
            backgroundColor: '#FFFFFF',
          }}
          className="mr-3 flex justify-center items-center"
        >
          <div
            style={{
              backgroundColor: '#FDFDFD',
              borderRadius: 20,
              height: 15,
              width: 15,
            }}
            className="flex justify-center items-center"
          >
            <HiShoppingBag size={20} color={'#507CDC'} />
          </div>
        </div>

        <label className="font-semibold">Cuentas por cobrar</label>
      </div>

      <div
        className="div2 relative shadow-lg overflow-x-auto overflow-y-hidden mt-2"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        {/* <div className="flex flex-row justify-center w-full items-center">
          <Switch checked={isUsd} onChange={handleChange} />
          <label className="font-semibold text-black text-center">
            Mostrar en USD (Ref.)
          </label>
        </div> */}

        <div className="text-center">
          <label className="font-semibold text-primary ">
            {isUsd
              ? stats?.accountReceivables.usdAmount
                ? `$ ${formatPipe(
                    stats?.accountReceivables.usdAmount,
                    false,
                    2,
                    -9999999999
                  )}`
                : `$ ${formatPipe(0 + '')}`
              : stats?.accountReceivables.bsAmount
              ? `Bs. ${formatPipe(
                  stats?.accountReceivables.bsAmount,
                  false,
                  2,
                  -9999999999
                )}`
              : `Bs. ${formatPipe(0 + '')}`
              }
          </label>
        </div>
      </div>

      <div
        className="div1 relative shadow-lg overflow-x-auto overflow-y-hidden mt-2"
        style={{
          backgroundColor: '#F6F7FC',
          borderColor: '',
          borderWidth: 0,
        }}
      >
        <div className="flex justify-between w-full">
          <div className="flex">
            <div
              style={{
                height: 28,
                width: 28,
                borderRadius: 20,
                backgroundColor: '#507CDC',
              }}
              className="mr-3 flex justify-center items-center"
            >
              <div
                style={{
                  backgroundColor: '#FDFDFD',
                  borderRadius: 20,
                  height: 15,
                  width: 15,
                }}
                className="flex justify-center items-center"
              >
                <IoBarChartSharp size={20} color={'white'} />
              </div>
            </div>

            <label className="font-semibold">Productos mas vendidos</label>
          </div>

          {/* <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={selectedCard === 0}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots className="cursor-pointer" onClick={() => setSelectedCard(0)} />
            </FloatingMenu> */}
        </div>

        <div className="mt-2">
          <div className="flex items-center justify-center">

          <label className="font-semibold text-black text-center">
              Servicios
            </label>

           
            <Switch checked={isProducts} onChange={handleChangeProducts} />

            <label className="font-semibold text-black text-center">
              Productos
            </label>


          </div>

          <div className="mt-2">
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedType}
                label="Age"
                onChange={handleChangeDropdown}
              >
                <MenuItem value={'annual'}>Anual</MenuItem>
                <MenuItem value={'monthly'}>Mensual</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="mt-14">
          <BarChart
            width={320}
            height={250}
            // width={div8Ref?.current?.offsetWidth}
            // height={div8Ref?.current?.offsetHeight}
            data={
              !isProducts
                ? stats?.topSold?.services?.[selectedType === 'annual' ? 'allYear' : 'currentMonth'].map((v) => ({
                    ...v,
                    totalQuantity: +v.totalQuantity,
                  }))
                : stats?.topSold?.products?.[selectedType === 'annual' ? 'allYear' : 'currentMonth'].map((v) => ({
                    ...v,
                    totalQuantity: +v.totalQuantity,
                  }))
            }
            barSize={30}
            // barGap={-70}
            // style={{ position: 'absolute' }}
          >
            {/* <Bar dataKey={'percent'} fill={'#507CDC'} fontWeight="bold" label={{position: 'end', fill: 'white'}} > */}
            <Tooltip content={<RenderTooltip />} />

            <XAxis dataKey="name" />
            <YAxis dataKey="totalQuantity" />

            <Bar
              dataKey={'totalQuantity'}
              fill={theme === 'dark' ? '#006AEA' : '#507CDC'}
              // label={{ position: "bottom", fill: "black", content: renderContent }}
              name="name"
            />



            {/* <LabelList
                angle={-90}
                content={renderContent}
                /> */}
            {/* </Bar> */}

            {/* <LabelList 
                  dataKey={'name'}
                  position="top"
                  angle={270}
                  offset={25}
                  fill='black'
                /> */}
            {/* { data02.map(v => <Cell />) }  */}
          </BarChart>
        </div>

        {/* <div
            className="flex justify-end absolute items-center"
            style={{ bottom: 0, padding: 'inherit', right: 0 }}
          >
            <IoCalendar className="text-primary mr-3" />
            <label className="text-xs">Filtrado Mes: Julio 2022</label>
          </div> */}
      </div>

      <div className="flex mt-5">
        <div
          style={{
            height: 28,
            width: 28,
            borderRadius: 20,
            backgroundColor: '#FFFFFF',
          }}
          className="mr-3 flex justify-center items-center"
        >
          <div
            style={{
              backgroundColor: '#FDFDFD',
              borderRadius: 20,
              height: 15,
              width: 15,
            }}
            className="flex justify-center items-center"
          >
            <HiAdjustments size={20} className="text-primary" />
          </div>
        </div>

        <label className="font-semibold">Porcentaje de ganancia bruta</label>
      </div>

      <div
        className="div2 relative shadow-lg overflow-x-auto overflow-y-hidden mt-2"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <div className="text-center">
          <label className="font-semibold text-primary ">
            {stats?.grossMargin?.monthGrossMargin}
          </label>
        </div>
      </div>

      <div className="flex mt-5">
        <div
          style={{
            height: 28,
            width: 28,
            borderRadius: 20,
            backgroundColor: '#FFFFFF',
          }}
          className="mr-3 flex justify-center items-center"
        >
          <div
            style={{
              backgroundColor: '#FDFDFD',
              borderRadius: 20,
              height: 15,
              width: 15,
            }}
            className="flex justify-center items-center"
          >
            <IoDocuments size={20} className="text-primary" />
          </div>
        </div>

        <label className="font-semibold">Inventario</label>
      </div>

      <div
        className="div2 relative shadow-lg overflow-x-auto overflow-y-hidden mt-2"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <div className="text-center">
          <label className="font-semibold text-primary text-center">
            Saldo total de las cuentas:
          </label>
        </div>

        <div className="text-center">
          <label className="font-semibold text-primary ">
            {`Bs. ${formatPipe(
              stats?.bankBalance?.totalBalance + '',
              false,
              2,
              -99999999999
            )}`}
          </label>
        </div>
      </div>

      <div className="flex mt-5">
        <div
          style={{
            height: 28,
            width: 28,
            borderRadius: 20,
            backgroundColor: '#FFFFFF',
          }}
          className="mr-3 flex justify-center items-center"
        >
          <div
            style={{
              backgroundColor: '#FDFDFD',
              borderRadius: 20,
              height: 15,
              width: 15,
            }}
            className="flex justify-center items-center"
          >
            <BsPersonFill size={20} className="text-primary" />
          </div>
        </div>

        <label className="font-semibold">Clientes</label>
      </div>

      <div
        className="div2 relative shadow-lg overflow-x-auto overflow-y-hidden mt-2 mb-[100px]"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <div className="flex flex-col items-center">
          <div className="flex justify-center items-center">
            <BsPersonFill size={20} className="text-primary" />

            <label className="font-semibold text-primary text-center ml-2">
              {stats?.clients.totalQty}
            </label>
          </div>

          <label className="font-semibold text-black text-center">
            Cantidad de clientes
          </label>
        </div>

        <div className="flex flex-col items-center mt-3">
          <div className="flex">
            <BsPersonFill size={20} className="text-primary" />

            <label className="font-semibold text-primary text-center ml-2">
              {stats?.clients.newInMonth}
            </label>
          </div>

          <label className="font-semibold text-black text-center">
            Clientes nuevos del mes
          </label>
        </div>
      </div>
    </div>
  )
}
